<template>
  <b-modal
    @hide="createModalClose"
    ref="createModal"
    :title="$t('文言カスタマイズ登録')"
    size="lg"
  >
    <b-container fluid>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('ベース文言') }}
          <span class="text-danger">&nbsp;{{ $t('※必須') }}</span>
        </label>
        <div class="col-sm-8">
          <select
            name="word"
            class="form-control input-sm"
            id="id_word"
            v-model="create.form.key"
          >
            <option selected></option>
            <template
              v-for="(value, key, index) in messageList"
              :keyed="`messageList-${index}`"
            >
              <option :value="key" :key="`messageList-${index}`">
                {{ value }}
              </option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('言語') }}
          <span class="text-danger">&nbsp;{{ $t('※必須') }}</span>
        </label>
        <div class="col-sm-8">
          <select
            name="language"
            class="form-control"
            id="id_language"
            v-model="create.form.languageCode"
          >
            <option value selected></option>
            <template>
              <option
                v-for="(item, index) in language"
                :key="index"
                :value="item.code"
              >
                {{ $t(item.name) }}
              </option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('カスタマイズ後') }}
          <span class="text-danger">&nbsp;{{ $t('※必須') }}</span>
        </label>
        <div class="col-sm-8">
          <input
            v-model="create.form.message"
            type="text"
            class="form-control"
          />
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="create.error">
        {{ create.error }}
      </p>
      <div
        class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100"
      >
        <button
          type="button"
          class="
            btn btn-success
            mr-3
            d-flex
            align-items-center
            justify-content-center
          "
          @click="createRegistration($event)"
          :disabled="create.registration"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="create.registration"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          @click="createModalClose()"
          v-if="!create.confirm"
          :disabled="create.registration"
        >
          {{ $t('キャンセル') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import language from '../../assets/json/language.json'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      language: language,
      create: {
        form: {
          languageCode: null,
          key: '',
          message: '',
        },
        registration: false,
        error: '',
      },
      messageList: [],
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async createModalOpen(item) {
      await this.getMessageData()
      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        if (copy.defaultMessage) copy.key = copy.defaultMessage
        delete copy.defaultMessage
        this.create.form = copy
      }
      this.$refs.createModal.show()
    },
    async getMessageData() {
      try {
        this.messageList = []
        const params = {
          languageCode: localStorage.lang, // ローカルの言語設定を使用する
          isSelection: true, // 変更可能項目のみ取得する
        }
        // NOTE: ベース文言一覧取得APIをコールする
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/defaultMessages`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: params,
          },
        )
        this.messageList = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async createRegistration() {
      const pwd = this.create.form
      if (!pwd.languageCode) {
        this.create.error = this.$t('言語') + this.$t('必須メッセージ')
        return
      } else if (!pwd.key) {
        this.create.error = this.$t('ベース文言') + this.$t('必須メッセージ')
        return
      } else if (!pwd.message) {
        this.create.error =
          this.$t('カスタマイズ後文言') + this.$t('必須メッセージ')
        return
      } else {
        this.create.error = ''
      }
      this.create.registration = true
      // 棚番情報登録のパラメーターを定義
      let params = {}
      for (let key of Object.keys(this.create.form)) {
        params[`${key}`] = this.mixin_deepcopy(this.create.form[key])
      }
      // console.log(params)
      let method = 'post'
      if (this.create.form.id) method = 'put'
      try {
        await this.$axios({
          method: method,
          url: `${this.$appConfig.CommonApiUrl}/message/custom`,
          data: params,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.createModalClose()
        this.$emit('registed')
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.create.registration = false
    },
    createModalClose() {
      this.create = {
        form: {
          languageCode: null,
          key: '',
          message: '',
        },
        list: [],
        registration: false,
        error: '',
      }
      this.$refs.createModal.hide()
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
